import React from "react";
import { Play, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NurturingTomorrowsLeaders() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="7907" id="where-ambition-meets-achievement" className="bg-background text-foreground relative overflow-hidden py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-8 items-center">
          {}
          <div ref={ref} className={`lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-6">
              <h1 className="font-default text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold leading-[1.1] tracking-tight">
                <span className="text-primary">
                  Where Ambition Meets Achievement.
                </span>
              </h1>
              <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
                Empowering global aspirations with expert guidance. Join thousands of students who have realized their dreams at the world's leading universities through our institutional prestige and personalized support.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="h-14 px-8 text-lg rounded-sm shadow-xl transition-all duration-300 bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="#">
                  Free Consultation
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>

              <Button variant="outline" size="lg" className="h-14 px-8 text-lg rounded-sm border-2 border-primary/10 bg-white/50 backdrop-blur-md hover:bg-accent text-primary group shadow-lg">
                <Play className="mr-2 h-5 w-5 fill-current group-hover:scale-110 transition-transform" />
                98% Visa Success
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative h-[500px] md:h-[600px] lg:h-[700px] w-full mt-8 lg:mt-0">
            {}
            <div className={`absolute top-0 right-0 w-[85%] h-[85%] transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
              <div className="relative w-full h-full rounded-sm overflow-hidden shadow-2xl">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623446/img/student_portrait_smiling.png" alt="A student in a library setting representing the Briviox standard of excellence" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700 grayscale-[20%]" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent pointer-events-none" />
              </div>
            </div>

            {}
            <div className={`absolute bottom-0 left-0 w-[60%] h-[40%] transition-all duration-1000 delay-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <div className="relative w-full h-full rounded-sm overflow-hidden shadow-xl border-4 border-background">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623446/img/modern_science_laboratory.png" alt="Global academic facilities accessible through Briviox consultancy" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700" />
              </div>
            </div>

            {}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-secondary/5 rounded-full blur-3xl" />
          </div>
        </div>
      </div>
    </section>;
}